export class CustomEventTarget {
    private listeners: Record<string, Array<{ listener: Function; options?: { capture?: boolean; once?: boolean } }>> = {};
  
    addEventListener(type: string, listener: Function, options?: { capture?: boolean; once?: boolean }) {
      if (!this.listeners[type]) {
        this.listeners[type] = [];
      }
      this.listeners[type].push({ listener, options });
    }
  
    removeEventListener(type: string, listener: Function) {
      if (!this.listeners[type]) return;
      //this.listeners[type] = this.listeners[type].filter((l) => l.listener !== listener);
      this.listeners[type] = this.listeners[type].filter((l) =>{
        var isFilter =  l.listener !== listener;
        return isFilter;
      });
      console.log("fasddf");
    }
  
    dispatchEvent(event: { type: string; [key: string]: any }) {
      const listeners = this.listeners[event.type];
      if (listeners) {
        // 先执行捕获阶段的监听器
        listeners
          .filter((l) => l.options?.capture)
          .forEach(({ listener, options }) => {
            listener(event);
            if (options?.once) {
              this.removeEventListener(event.type, listener);
            }
          });
  
        // 执行目标阶段的监听器
        listeners
          .filter((l) => !l.options?.capture)
          .forEach(({ listener, options }) => {
            listener(event);
            if (options?.once) {
              this.removeEventListener(event.type, listener);
            }
          });
      }
    }
  }